import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { LocalizationService } from '../../services/localization.service';

@Component({
  selector: 'app-pagination-v1',
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss'
})
export class PaginationComponent implements OnInit {
  @Input({ required: true }) currentPage: number;
  @Input({ required: true }) totalRecords: number;
  @Input({ required: true }) pageSize: number;
  @Input({ required: true }) pageSizes: number[];

  @Output() loadData = new EventEmitter<{
    currentPage: number;
    pageSize: number;
  }>();

  constructor(private localizationService: LocalizationService) { }

  getPreviousArrow(): string {
    return this.localizationService.getCachedLanguage() === 'ar' ?
      "assets/media/general/right-arrow.svg" :
      "assets/media/general/left-arrow.svg";
  }

  getNextArrow(): string {
    return this.localizationService.getCachedLanguage() !== 'ar' ?
      "assets/media/general/right-arrow.svg" :
      "assets/media/general/left-arrow.svg";
  }


  get startRecord(): number {
    return (this.currentPage - 1) * this.pageSize + 1;
  }

  get endRecord(): number {
    const end = this.currentPage * this.pageSize;
    return end > this.totalRecords ? this.totalRecords : end;
  }

  get pages(): number[] {
    const length = this.getTotalPages();
    return Array.from({ length }, (_, i) => i + 1);
  }

  getTotalPages(): number {
    return Math.ceil(this.totalRecords / this.pageSize);
  }

  ngOnInit(): void {
    // this.updatePageSize();
  }

  goToPreviousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.loadData.emit({
        currentPage: this.currentPage,
        pageSize: this.pageSize
      });
    }
  }

  get visiblePages(): number[] {
    const rangeSize = 5;
    let startPage = Math.max(this.currentPage - Math.floor(rangeSize / 2), 1);
    let endPage = startPage + rangeSize - 1;
    const totalPages = this.getTotalPages();

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(endPage - rangeSize + 1, 1);
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  }

  goToNextPage(): void {
    const totalPages = this.getTotalPages();

    if (this.currentPage < totalPages) {
      this.currentPage++;
      this.loadData.emit({
        currentPage: this.currentPage,
        pageSize: this.pageSize
      });
    }
  }

  goToPage(page: number): void {
    const totalPages = this.getTotalPages();

    if (page !== this.currentPage && page >= 1 && page <= totalPages) {
      this.currentPage = page;
      this.loadData.emit({
        currentPage: this.currentPage,
        pageSize: this.pageSize
      });
    }
  }

  updatePageSize(): void {
    this.currentPage = 1;

    this.loadData.emit({
      currentPage: this.currentPage,
      pageSize: this.pageSize
    })
  }
}
